<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">选择老人</div>
        <el-button type="button" class="btn-close" @click="closeSelf">X</el-button>
      </div>
      <div class="modal-body" style="padding: 10px;">

        <el-row>
          <div style="float:right;">
            <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 5px;width:200px"></el-input>
            <el-input  placeholder="请输入手机号" v-model="phone" clearable style="margin:0 5px;width:200px"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="getElderly">查询</el-button>
          </div>
        </el-row>

        <el-row style="margin-top:10px">
          <el-col :span="24">
            <el-table :data="elderlyInfo" style="width: 100%" border :height="400">
              <el-table-column label="姓名" prop="name" width="100"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>
              <el-table-column prop="zoneName"  label="组织" ></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click.native.prevent="handleAdd(scope.$index, scope.row)">选择</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>

        <div class="page" style="margin-top: 10px;">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'SelectElderly',
  data() {
    return {

      name:'',
      phone:'',
      loading: false,

      elderlyInfo:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',

      th:this.$store.state.tableHeight,

      zoneValue: [],
      zoneCode: '',

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val
    },
  },
  methods: {
    init(){

      this.getElderly()

    },
    closeSelf() {
      this.$emit("closeSelectElderly");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getElderly();
    },
    handleAdd(index, row) {
      this.$emit("setElderly",row);
      this.$emit("closeSelectElderly");
    },

    getTime(row,index,column){
      return timefilters(column)
    },
    userStatus(row) {
      if (row.userStatus == 1) {
        return "正常";
      }
      if (row.userStatus == 2) {
        return "禁用";
      }
      return "其它";
    },

    getElderly(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/PageForGovernmentCode",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          name:this.name,
          phone:this.phone,
          status:-1,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          zoneCode:"",
        }
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.elderlyInfo=response.data.data.list;
              this.totalItems = response.data.data.total;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })
    },

  }
}


</script>




